// hooks/useFormViewerWizard/step1Sig.ts — tanda sesi step 1 (keranjang + identitas).
// Termasuk nama/WA/alamat: edit kecil lalu Kembali→Lanjut WAJIB mem-PATCH order
// sesi (dulu hanya varian/qty → nama/WA/alamat baru hilang diam-diam).
export function buildStep1Sig(hook: any): string {
    const addr = (hook?.addressData || {}) as any;
    return JSON.stringify({
        o: hook?.selectedOptions || {}, q: hook?.quantity || 1,
        n: String(hook?.customerData?.name || '').trim(),
        p: String(hook?.customerData?.whatsapp || '').trim(),
        a: String(addr?.detailAddress || addr?.fullAddress || '').trim(),
    });
}
